import { useState } from 'react';

const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [keys, setKeys] = useState([]);
  const [expandedKey, setExpandedKey] = useState(-1);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalCount, setTotoalCount] = useState(0);

  const [token, setToken] = useState(null);
  const [newTokenLoading, setNewTokenLoading] = useState(false);
  const [tokenShowcaseOpen, setTokenShowcaseOpen] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteTokenLoading, setDeleteTokenLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [hidePass, setHidePass] = useState(true);
  const [imageIsLoaded, setImageIsLoaded] = useState(false);



  
  return {
    activeStep, setActiveStep,
    skipped, setSkipped,
    loading,
    setLoading,
    hidePass, setHidePass,
    imageIsLoaded, setImageIsLoaded,
    openDialog,
    setOpenDialog,
    currentPage, setCurrentPage,
    totalCount, setTotoalCount,
    keys,
    setKeys,
    expandedKey,
    setExpandedKey,
    openDialog,
    setOpenDialog,
    token,
    setToken,
    newTokenLoading,
    setNewTokenLoading,
    tokenShowcaseOpen,
    setTokenShowcaseOpen,
    confirmDeleteOpen,
    setConfirmDeleteOpen,
    deleteTokenLoading,
    setDeleteTokenLoading,
  };
};

export default useCustomHook;
